<div class="cards-container" *ngIf="userCards.length > 0">
  <div class="cards-title {{classType}}">
    Método de pago
  </div>
  <div class="cards-list-container">
    <div 
      class="cards-list {{classType}}" 
      *ngFor="let card of userCards"
      [ngClass]="{'expired': card.expired}"
      (click)="selectCard(card)">
      <div class="cards-brand-name">
        <i 
          class="iconlace iconlace-check-status {{classType}}"
          [ngClass]="{'active-check': (cardSeleted?.cardId == card.cardId && !card.expired),'expired': card.expired}"
        >
        </i>
        <span 
          class="cards-text desk"
          [ngClass]="{'expired': card.expired}">
          {{card.cardBrandName}} que termina en {{card.last4}}
        </span>
        <span 
          class="cards-text mobile">
          {{ card.cardBrandName }} - {{card.last4}}
        </span>
        <span 
          *ngIf="card.expired" 
          class="cards-expired" 
          placement="top" 
          [ngbTooltip]="tooltipText">
          VENCIDA
        </span>
      </div>
      <div 
        class="cards-text" 
        [ngClass]="{'expired': card.expired}">
        {{card.expMonth}} / {{card.expYear}}
      </div>
    </div>
  </div>
  <div *ngIf="classType === 'missionary'" class="cards-help">
    <span 
      class="cards-help-text" 
    >
      *Este será tu medio de pago primario.
    </span>
  </div>
</div>
